import React from 'react';
import { observer } from 'src/utils/mobx-react';
import Header from 'src/components/Header';
import { CmsMenuItems } from 'src/components/CmsPageNavigation/CmsPageNavigation';
import { LayoutWrapper, MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';
import { CmsPageContent } from 'src/layouts/CmsPage/CmsPageContent';

export const CmsPage = observer('CmsPage', (): React.ReactElement => {
    return (
        <LayoutWrapper>
            <Header />

            <MainContainer>
                <CmsMenuItems />
                <CmsPageContent />
            </MainContainer>
        </LayoutWrapper>
    );
});
